import { Prisma } from '@prisma/client';
import { SharePageInclude } from '../includes/SharePage';
var IncludeSharePage = Prisma.validator()({
    include: SharePageInclude,
});
//# sourceMappingURL=SharePage.js.map